import React, { Fragment } from 'react';

import { useModalsState } from '~src/contexts/ModalsContext';
import { DeleteModal } from '~components/popups-modals/Delete.modal';
import { MoveModal } from '~components/popups-modals/Move.modal';
import { ShareModal } from '~components/popups-modals/Share.modal';
import { RestoreToModal } from '~components/popups-modals/RestoreTo.modal';
import { CopyModal } from '~components/popups-modals/Copy.modal';
import { EditFolderModal } from '~components/popups-modals/EditFolder.modal';
import { EditFileModal } from '~components/popups-modals/EditFile.modal';
import { CreateFolderModal } from '~components/popups-modals/CreateFolder.modal';
import { PdfCompareModal } from '~components/popups-modals/PdfCompare.modal';
import { PrimaryPreviewInfoModal } from '~components/popups-modals/PrimaryPreviewInfo.modal';
import { CorrelationLetterModal } from '~components/popups-modals/MovementsModals/CorrelationLetter.modal';
import { ResendInviteModal } from '~components/popups-modals/ResendInvite.modal';
import ReactivateShareModal from '~components/popups-modals/TenderSharesModal/ReactivateShare.modal';
import { jsx } from '@emotion/core';
import InviteModal from '~components/popups-modals/InviteModal/InviteModal.modal';
import { ProjectBuilderModal } from '~components/popups-modals/ProjectBuilderModal/ProjectBuilderModal';
import { ImportTemplateModal } from '~components/popups-modals/ImportTemplateModal/ImportTemplateModal';

/** Containes all action modals, should be rendered as child of `ModalsProvider` */
export const ActionModalsContainer: React.FC = () => {
  const modalsState = useModalsState();

  return (
    <Fragment>
      {/* TODO: add all other modals, and replace in RightSideView & LeftSideView */}
      <ShareModal {...modalsState.shareModal} />
      <DeleteModal {...modalsState.deleteModal} />
      <MoveModal {...modalsState.moveModal} />
      <RestoreToModal {...modalsState.restoreToModal} />
      <CopyModal {...modalsState.copyModal} />
      <EditFolderModal {...modalsState.editFolderModal} />
      <EditFileModal {...modalsState.editFileModal} />
      <CreateFolderModal {...modalsState.createFolderModal} />
      <PdfCompareModal {...modalsState.pdfCompare} />
      <CorrelationLetterModal {...modalsState.correlationLetterModal} />
      <ResendInviteModal {...modalsState.resendInvite} />
      <ReactivateShareModal {...modalsState.reactivateShare} />
      <PrimaryPreviewInfoModal {...modalsState.primaryPreviewInfo} />
      <InviteModal {...modalsState.inviteVendorsModal} />
      <ProjectBuilderModal {...modalsState.projectBuilderModal} />
      <ImportTemplateModal {...modalsState.importTemplateModal} />
    </Fragment>
  );
};
